
import base from "./base.service";

const instance = base.service();

export const getAll = () => {
    return instance.get("/pitanje/all");
};

export const deletePitanje = (id) =>
{
    return instance.delete(`/pitanje/${id}`);
}

export const updatePitanje = (id, updatedPitanje) =>
    {
        return instance.put(`/pitanje/${id}`, updatedPitanje);
    }

export const addPitanje = (novoPitanje) =>
{
    return instance.post("/pitanje", novoPitanje);
}

export const getById = (id) =>
{
    return instance.get(`/pitanje/${id}`);
}

export const getByAnketaId = (id) =>
    {
        return instance.get(`/anketa/${id}/pitanja`);
    }

export default
{
    getAll,deletePitanje, addPitanje, getById, getByAnketaId, updatePitanje
};